export const chinese = {
  // 顶部导航栏
  homeView: {
    menuList: {
      index: '首页',
      about: '关于我们',
      products: '产品',
      technology: '技术与设备',
      contact: '联系我们',
      synopsis: '奥图简介',
      develop: '发展历程',
      honor: '奥图荣耀',
      team: '奥图团队',
      spring: '弹簧产品系列',
      hardware: '五金产品系列',
      echnicalAdvantages: '技术优势',
      productionEquipment: '生产设备',
      inspectionEquipment: '检测设备',
      workshopEnvironment: '车间环境',
    }
  },
  // 底部栏
  footer: {
    footerAbout: '关于我们',
    footerProducts: '产品',
    footerTechnology: '技术与设备',
    footerContact: '联系我们',
    footerSynopsis: '奥图简介',
    footerDevelop: '发展历程',
    footerHonor: '奥图荣耀',
    footerTeam: '奥图团队',
    footerSpring: '弹簧产品系列',
    footerHardware: '五金产品系列',
    footerEchnicalAdvantages: '技术优势',
    footerProductionEquipment: '生产设备',
    footerInspectionEquipment: '检测设备',
    footerWorkshopEnvironment: '车间环境',
    footerTel: '电话：( 86 ) 20 - 8662 9332',
    footerFax: '传真：( 86 ) 20 - 8662 9332',
    footerEmail: '邮箱：Info@autospring.cn',
    footerAddress: '地址：广州经济技术开发区东区沧联小迳东路',
    footerInfo: 'Copyright 2023-2028 autospring.cn | 奥图弹簧版权所有 | 粤ICP备14017194号-2',
  },
  // 首页
  indexPage: {
    categoryNavigation: '分类导航 /',
    classification: 'CLASSIFICATION',
    springTitle: '弹簧产品系列',
    springTitleEN: 'SPRING SERIES',
    buttonText: '查看详情',
    hardwareTitle: '五金产品系列',
    hardwareTitleEN: 'METAL HARDWARE SERIES',
    middleTitleOne: '规格多样',
    middleTitleTwo: '诚信经营',
    middleTitleThree: '加工定制',
    middleTitleFour: '售后完善',
    middleTitleFive: '货源充足',
    middleSubTitleOne: 'DIVERSE STYLES',
    middleSubTitleTwo: 'THE GOOD FAITH MANAGEMENT',
    middleSubTitleThree: 'PROCESSING CUSTOMIZED',
    middleSubTitleFour: 'PERFECT AFTER-SALES',
    middleSubTitleFive: 'PLENTIFUL',
    middleTextOneFir: '产品多种规格',
    middleTextOneSec: '满足您的需求',
    middleTextTwoFir: '诚信共赢、真材实料',
    middleTextTwoSec: '责任担当、感恩奉献',
    middleTextThreeFir: '支持加工定制',
    middleTextThreeSec: '具体联系客服',
    middleTextFourFir: ' 贴心服务',
    middleTextFourSec: '放心购买',
    middleTextFiveFir: '货源充足',
    middleTextFiveSec: '满足大批量订购',
    aboutTitleEN: 'ABOUT US',
    aboutTitleZH: '关于我们',
    aboutListOne: '1984年成立于香港',
    aboutListTwo: '1998年独资成立广州奥图弹簧有限公司注册资本3000万( 港币 )，港资企业',
    aboutListThree: '通过ISO9001、ISO14001、IATF16949',
    aboutListFour: '提供出口、转厂、内销一站式服务模式',
    aboutListFive: '占地面积25500m², 实用厂房面积24500m²',
    aboutListSix: '拥有人员年平均620人, 两班生产',
    aboutListSeven: '专业生产各类弹簧及五金冲压产品',
    aboutListEight: '拥有弹簧设备330台及50多台级进模冲床',
    aboutListNine: '年产弹簧23亿件, 冲压件2.1亿件',
    aboutDetails: '查看详情',
    aboutFooterTitleOne: '“ 起源于1984 ”',
    aboutFooterTitleTwo: '“ 丰富的生产经验 ”',
    aboutFooterTitleThree: '“ 强大生产能力 ”',
    aboutFooterTitleFour: '“ 大型实体厂房 ”',
    aobutFooterNumOne: '39',
    aobutFooterNumTwo: '500',
    aobutFooterNumThree: '23',
    aobutFooterNumFour: '24500',
    aboutFooterUnitOne: '年',
    aboutFooterUnitTwo: '+名',
    aboutFooterUnitThree: '+亿',
    aboutFooterUnitFour: 'm²',
    aboutFooterExplainOne: '行业经验',
    aboutFooterExplainTwo: '生产人员',
    aboutFooterExplainThree: '年产弹簧',
    aboutFooterExplainFour: '厂房面积',
    honorTitleZH: '荣誉证书 /',
    honorTitleEN: 'CERTIFICATE OF HONOR',
    customerTitleZH: '合作客户 /',
    customerTitleEN: 'COOPERATIVE CUSTOMER'
  },
  // 关于我们
  about: {
    breadcrumb: '当前位置： 关于我们  >  ',
    aboutTitleZH: '关于我们',
    aboutTitleEN: 'ABOUT US',
    synopsis: '奥图简介',
    develop: '发展历程',
    honor: '奥图荣耀',
    team: '奥图团队',
    phoneTitle: '服务咨询热线：',
    phoneNum: '020-8226 9332',
    synTitleOneZH: '企业简介',
    synTitleOneEN: 'Enterprise Introduction',
    synTitleTwoZH: '企业理念',
    synTitleTwoEN: 'Enterprise Philosophy',
    synTitleTopOne: '弹簧工厂',
    synTitleTopTwo: '五金工厂',
    aboutListOne: '1984年成立于香港',
    aboutListTwo: '1998年独资成立广州奥图弹簧有限公司注册资本3000万( 港币 )，港资企业',
    aboutListThree: '通过ISO9001、ISO14001、IATF16949',
    aboutListFour: '提供出口、转厂、内销一站式服务模式',
    aboutListFive: '占地面积25500m², 实用厂房面积24500m²',
    aboutListSix: '拥有人员年平均500人, 两班生产',
    aboutListSeven: '专业生产各类弹簧及五金冲压产品',
    aboutListEight: '拥有弹簧设备330台及50多台级进模冲床',
    aboutListNine: '年产弹簧23亿件, 冲压件2.1亿件',
    philosophyTitleTwo: '企业愿景',
    philosophyTitleOne: '企业使命',
    philosophyTitleThree: '企业价值观',
    philosophyTitleFour: '质量方针',
    philosophyTextTwo: '面向世界，实现工业智造，成就百年企业',
    philosophyTextOne: '专业的产品与服务，让出行更安全，让生活更精彩',
    philosophyTextThree: '专业，创新，务实，价值',
    philosophyTextFour: '品质至上，诚信务实，永攀新高，持续发展',
    developmentTitleZH: '发展历程',
    developmentTitleEN: 'Development Course',
    developYearOne: '2019年至今',
    developYearTwo: '2003年',
    developYearThree: '2000年',
    developYearFour: '1998年',
    developYearFive: '1984年',
    developInfoOneCom: '奥图弹簧五金分厂扩建 ( 宝丰分厂 )',
    developInfoOneArea: '面积: 11000平方米',
    developInfoTwoCom: '广州奥图弹簧有限公司成立黄埔',
    developInfoTwoMain: '主营：精密弹簧、 五金冲压',
    developInfoTwoNum: '人员: 480',
    developInfoTwoArea: '面积: 13000平方米',
    developInfoThreeCom: '深圳奥特图弹簧有限公司成立于深圳沙井',
    developInfoThreeMain: '主营：精密弹簧',
    developInfoThreeNum: '人员: 80',
    developInfoThreeArea: '面积: 4000平方米',
    developInfoFourCom: '广州奥图弹簧有限公司成立广州东圃',
    developInfoFourMain: '主营：精密弹簧',
    developInfoFourNum: '人员: 80',
    developInfoFourArea: '面积: 3000平方米',
    developInfoFiveCom: '公司成立于香港',
    developInfoFiveMain: '主营：精密弹簧',
    developInfoFiveNum: '人员: 30',
    developInfoFiveArea: '面积: 1000平方米',
    honorTitleZH: '奥图荣誉',
    honorTitleEN: 'Auto Honor',
    honorTitleOne: '研发技术中心',
    honorTextOne: '公司已获得一系列的企业荣誉与资质认定。公司2014年已通过国家高新技术企业认定, 2015年通过广州市市级企业技术中心认定, 拥有广东省著名商标及广州市著名商标。 2017年认定为广东省技术中心。2023年认定为专精特新中小企业。',
    honorTitleTwo: '发明专利',
    honorTextTwo: '公司推行改善文化，拥有四十多项发明专利。',
    honorTitleThree: '体系证书',
    honorTextThree: '公司已获得ISO9001:2015 、 ISO14001:2015、IATF16949:2016体系证书。',
    honorTitleFour: '部分企业荣誉',
    honorYearOne: '2011年',
    honorYearTwo: '2013年',
    honorYearThree: '2017年',
    honorYearFour: '2018年',
    honorYearFive: '2019年',
    honorYearSix: '2022年',
    honorYearSeven: '2023年',
    honorYearEight: '2023年',
    honorExplainOne: '荣获比亚迪汽车有限公司',
    honorExplainOne02: '积极配合奖',
    honorExplainTwo: '荣获歌尔声学股份有限公司',
    honorExplainTwo02: '最佳竞争力奖',
    honorExplainThree: '荣获柳州五菱汽车工业有限公司',
    honorExplainThree02: '优秀供应商',
    honorExplainFour: '荣获阿尔法(广州)汽车配件有限公司',
    honorExplainFour02: '优秀供应商',
    honorExplainFive: '荣获有信制造(中山)有限公司',
    honorExplainFive02: '优秀供应商',
    honorExplainSix: '荣获广东高壹工机有限公司',
    honorExplainSix02: '优秀供应商',
    honorExplainSeven: '荣获上海恩井汽车科技有限公司',
    honorExplainSeven02: '优秀质量奖',
    honorExplainEight: '荣获富临精工(芯智热控技术)有限公司',
    honorExplainEight02: '技术贡献奖',
    cultureTitleZH: '企业文化',
    cultureTitleEN: 'Enterprise Culture',
    cultureMainTextOne: '奥图经过近三十年运营，深信优秀的企业文化乃做好百年基业之根本，坚持以人为本，诚信经营，高度重视企业文化的塑造，执行完善的管理体制、有效的人岗匹配性、透明的沟通氛围，及有洞察力和观察细微的全面评估体系。',
    cultureMainTextTwo: '奥图文化民彩纷呈, 成立奥图工会, 每年开展多项活动: 如员工旅游、员工体检、篮球赛、拔河赛、桌球赛、6S知识竞赛、装拆模比赛等, 促使每位员工都充分发挥工作热情和创造力, 塑造出具有高度凝聚力和忠诚度的善于克难攻坚的高素质员工团队, 为企业发展提供源源不断的动力, 稳健提升企业优秀核心竞争力。',
    cultureTitleOne: '企业文化 — 拓展活动',
    cultureImgTitleOne: '启动大会',
    cultureImgTitleTwo: '拔河比赛',
    cultureImgTitleThree: '员工旅游',
    cultureImgTitleFour: '拓展游戏',
    cultureImgTitleFive: '户外拓展',
    cultureImgTitleSix: '户外拓展',
    cultureImgTitleSeven: '羽毛球比赛',
    cultureImgTitleEight: '员工生日会',
    cultureImgTitleNine: '一星班组',
    cultureTitleTwo: '企业文化— 培训',
    cultureTitleThree: '企业文化— 改善',
    cultureTextOne: '公司每年开展大小型培训和沙盘活动累计参与人次2000人以上。',
    cultureTextTwo: '公司不断改善创新: 每年改善提案约300个, 一周一改善约500个, 贯彻10大改善精神。',
    cultureMationTitle: '十大改善精神',
    cultureMationTextOne: '打破固有观念，敢于否定现状',
    cultureMationTextTwo: '寻找可行的办法，不说『 不可能 』',
    cultureMationTextThree: '不要辩解，迅速执行',
    cultureMationTextFour: '不要求完美, 50分也好, 立即实施',
    cultureMationTextFive: '错了马上改善',
    cultureMationTextSix: '改善无极限',
    cultureMationTextSeven: '遇到问题，首先想到是自己的责任',
    cultureMationTextEight: '追求根源, 反复5次『 为什么 』',
    cultureMationTextNine: '十个人的智慧，比一个人的智慧高明',
    cultureMationTextTen: '先从不花钱的改善做起',
    technicalTitleZH: '技术人员 ',
    technicalTitleEN: 'Technical Personnel',
    industryTitleZH: '行业地位 ',
    industryTitleEN: 'Industry Position',
    industryTextOne: '开发生产产品主要用于汽车，航空电器，高精密电路控制器，家用电器，办公用电子电脑，手机通讯，建筑五金，医疗器械等遍及全球所有工业产品领域使用的弹簧及精密冲压五金部件等30多项行业国际先进技术。',
    industryTextTwo: '为博世，本田，通用电器，法雷奥，比亚迪，麦格纳，苹果，惠普，美芝压缩机，京西重工等国际知名客户提供一站式服务，并获得多项荣誉。先后与瑞典弹簧协会Lesjofors集团，德国Spring Tec Group集团，华南金属研究所，中钢集团郑州金属制品研究院，贵州钢绳股份技术中心，进行科研生产联合体。',
    industryTextThree: '同时注重引进、培养各类专业技术人才，建立起高素质的科研开发队伍，产品属于高科技精密零件，生产工艺高度自动化、技术处于国内领先水平，年产销量均居国内前茅，产品质量达到国内外同类先进或领先水平。',
    domesticTitleZH: '国内地位',
    domesticTitleEN: 'Domestic Status',
    domesticTextOne: '奥图是国内生产规模线径范围最广（0.03-16mm）、产能规模最大、同时也可以配套生产五金冲压产品及零部件、技术实力雄厚、客户产品涵盖最广的生产企业之一；多次参与修订新的弹簧用碳素钢丝的标准，参与国家技术标准化的合作单位。',
    domesticTextTwo: '公司技术研发中心依靠自身多年探索，克服国内外技术障碍，参与客户设计开发了多项弹簧和五金类产品，申请了40多项专利，并填补同类产品的国内空白，如双线同时卷制弹簧的工艺及产品、超精细塔型安全位弹簧、自动尾门弹簧、VVT项目的成功研发结束了必须依靠进口德系和意系的垄断，降低客户成本并能快速响应客户需求。',
    strategicTitleZH: '战略规划',
    strategicTitleEN: 'Strategic Planning',
    strategicText: '得益于中国在全球市场的持续发展壮大，我们紧贴市场脉搏，坚持自主研发，不断创新，30多年来，不断精益求精，战胜一次一次的技术难关及市场的挑战，赢得了国内外客户的高度认可，未来，公司的主要市场竞争会更加激烈，我们将持续深化耕耘以下主营业务。',
    objectiveTitleZH: '战略目标',
    objectiveTitleEN: 'Strategic Objective',
    objectiveTextOne: '2025年 营收预计8.45亿',
    objectiveTextTwo: '2024年 营收预计6.50亿',
    objectiveTextThree: '2023年 营收预计5.00亿',
  },
  // 联系我们
  contact: {
    bannerTitleOne: '一切从',
    bannerTitleTwo: '聆听',
    bannerTitleThree: '开始',
    bannerText: '把您的需求告诉我们，让我们优秀的团队为您服务!',
    breadcrumb: '当前位置： 联系我们',
    contactTitleZH: '联系我们',
    contactTitleEN: 'Contact Us',
    compNameZH: '广州奥图弹簧有限公司',
    compNameEN: 'GUANGZHOU AUTO SPRING CO.,LTD.',
    compAdd: '地址：广东省广州市黄埔区小迳东路',
    compTel: '电话：( 86 ) 20-8226 9332',
    compFax: '传真：( 86 ) 20-8226 9339',
    compZip: '邮编：510760',
    compEmail: '邮箱：Info@autospring.cn',
    compWeb: '网址：www.autospring.cn',
    phoneTitleZH: '咨询热线：',
    phoneNum: '+86 20-82269332',
  },
  // 技术与设备
  technology: {
    bannerTitleOne: '您的满意',
    bannerTitleTwo: '就是我们专业的表达',
    bannerTitleThree: '三十几载的行业经验，出彩专业经验与执行能力',
    bannerTitleFour: '成功服务上万家客户',
    breadcrumb: '当前位置： 技术与设备  >  ',
    technologyTitleZH: '技术与设备',
    technologyTitleEN: 'Technology and equipment',
    advantage: '技术优势',
    produce: '生产设备',
    detect: '检测设备',
    environment: '车间环境',
    phoneTitle: '服务咨询热线：',
    phoneNum: '020-8226 9332',
    advantageTitleZH: '技术优势',
    advantageTitleEN: 'Technology And Equipment',
    advantageMainTitleOne: '技术优势 — 弹簧篇',
    advantageMainTitleTwo: '技术优势 — 五金篇',
    listTitleOne: '强大的工艺及设备开发能力',
    listTextOne: '公司技术研发中心依靠自身多年探索，克服国内外技术障碍，参与客户设计开发了多项弹簧和五金类产品，申请了40多项专利，并填补同类产品的国内空白，如双线同时卷制弹簧的工艺及产品、超精细塔型安全位弹簧、自动尾门弹簧、VVT项目的成功研发结束了必须依靠进口德系和意系的垄断，降低客户成本并能快速响应客户需求。',
    listTitleTwo: '全面专业的试验检测能力',
    listTextTwo: '拥有各种先进的全自动高精密的力学测量设备20多台，最小读值0.001N，光学影像及3D测量10多台，各类环境及恒温恒湿测试多台，能够对材料及产品力学，空间尺寸，材料特性及金相组织结构，表面耐蚀性，不同温度的耐松弛性，疲劳特性，清洁度等提供全面专业的技术质量报告。同时公司还开发应用了大量的在线检测技术。',
    listTitleThree: '专业的研发团队',
    listTextThree: '公司拥有30多名丰富经验的金属材料，自动化控制专业技术研发骨干，依客户设计概念或使用工况，基于有限元通过CAE分析，提供专业的弹簧结构，应力验算，疲劳分析等设计建议，让设计变得更合理更安全。专业团队对设备功能扩展，增加防错预警及安全装置；自行开发专用设备及特种工装。',
    listTitleFour: '专业的工装模具制作',
    listTextFour: '“中国智造”不仅仅体现自动化和智能化，还必须确保制程能力稳定性为前提，这就需要我们的丰富经验的PE人员专业的设计及高精度的各类CNC模治具加工设备为保障。',
    listTitleFive: '丰富的产品生产线',
    listTextFive: '我们拥有300多台各类型号的CNC弹簧加工设备和50多台（16-300T）级进模冲床及模具加工设备，线径覆盖0.03mm-16mm，板材厚度0.05-5mm，可以加工钢，铁，铝，稀有合金，不锈钢，铜及其合金等，为客户提供各种高效专业的解决方案。',
    listTitleSix: '丰富的表面处理技术',
    listTextSix: '低温渗氮，MAGNI，植绒，改性粉末有机复合涂层，镀厚金等。提高防腐蚀，耐摩擦，降低噪声同时又延长疲劳效果。',
    listTitleSeven: '专业的工程技术团队',
    listTextSeven01: '★  技术团队熟悉IATF16949体系',
    listTextSeven02: '★  熟悉系统化新产品开发流程及客户系统',
    listTextSeven03: '★  对材料选用、合理工艺规划具有丰富经验',
    listTextSeven04: '★  CAE分析能力、配合客户研发的经验',
    listTextSeven05: '★  汽车、精密电子类模具设计制作丰富经验',
    listTextSeven06: '★  产品开发过程问题对策与解决的丰富经验',
    listTitleEight01: '强大的专用制造',
    listTitleEight02: '用工装、设备开发能力',
    listTextEight01: '★  专用零件组装设备的开发能力',
    listTextEight02: '★  专用冲床周边辅助设备开发能力',
    listTextEight03: '★  专用后工序减人工装、设备开发能力等',
    listTitleNine01: '强大的专用检测',
    listTitleNine02: '用工装、设备开发能力',
    listTextNine01: '★  CCD全检设备开发能力',
    listTextNine02: '★  专用气密性检测设备开发能力',
    listTextNine03: '★  专用检测治具开发能力',
    listTextNine04: '★  其它专用试验设备开发能力等',
    listTitleTen01: '各类型冲压模具的',
    listTitleTen02: '开发经验',
    listTextTen01: '★  630T及以下连续模开发',
    listTextTen02: '★  630T及以下机械手传送模开发',
    listTextTen03: '★  高精度拉伸连续、传送模开发',
    listTextTen04: '★  材料厚度0.1~6MM区间模具开发',
    listTitleEle: '广泛的材料适配能力',
    listTextEle01: '★  丰富的工艺规划经验及结构设计能力',
    listTextEle02: '★  精密的加工、制造设备',
    listTextEle03: '★  强大的供应链体系',
    listTextEle04: '★  满足各类铝铜、合金，0.1~6MM厚度的不锈钢、高强板、拉伸材料等的冲压加工',
    listTitleTwe: '涵盖面广，种类多样的产品线',
    listTextTwe01: '★  16~400T区间50余台设备的连续冲压制造能力',
    listTextTwe02: '★  配套的模具制造能力',
    listTextTwe03: '★  配套的专用工装制造能',
    listTextTwe04: '★  配套的清洗除油能力',
    listTextTwe05: '★  配套的产线后处理能力',
    listTitleThi: '强有力的供应商整合能力',
    listTextThi01: '★  各关键岗位负责人熟悉行业状况',
    listTextThi02: '★  采购大数据管理系统的支持',
    listTextThi03: '★  强大的供应商优选、评价、管理体系',
    listTextThi04: '★  充分利用行业资源的能力',
    listTextThi05: '★  先人一步的快速反应能力',
    produceTitleZH: '生产设备',
    produceTitleEN: 'Production Equipment',
    produceMainTitleOne: '生产设备 — 弹簧篇',
    produceMainTitleTwo: '生产设备 — 五金篇',
    produceTitleNum: '设备数量：',
    produceTitleSpecialty: '设备特长：',
    produceTitleMain: '主攻产品：',
    produceTitleDay: '日产量：',
    produceTitleMonth: '月产量：',
    produceTitleYear: '年产量：',
    produceListTitleOne: '弹簧自动立定设备',
    produceListTextOne: '面临人力成本居高临下，以往依靠人员手工作业，通过自主研发设备，产品通过自动生产线完成工序要求，提高生产效率和降低制造成本',
    produceListTitleTwo: '全自动多功能折角机',
    produceListTextTwo: '针对汽车门锁拉杆类产品进行自主研发专用的折角设备，效率提高50%',
    produceListTitleThree: '全自动旋锻机',
    produceListTextThree: '针对汽车门锁拉杆类产品进行自主研发专用的旋锻设备，打破原有旋锻设备的加工方式思维，效率提高50%；专门成立6条生产线生产拉杆类产品',
    produceListTitleFour: '台湾精密压簧机',
    produceListTextFour01: '60台',
    produceListTextFour02: '设备精度高，生产产品稳定性高，产品外经最小公差可控制在0.01mm,长度公差可控制0.02mm；每台机配置自动检长机，生产过程自动监控产品的长度，长度出现偏离可进行自动修复，超出公差范围自动分离功能，有效的保证产品质量',
    produceListTextFour03: 'φ0.1以上的压力弹簧',
    produceListTextFour04: '5000万PCS',
    produceListTitleFive: '台湾7轴大压簧机',
    produceListTextFive01: '5台',
    produceListTextFive02: '7轴单独操作；换型简便；效率高',
    produceListTextFive03: 'φ3.0以上的各种大压簧。目前主要生产汽车离合器、发动机、汽车尾门类型产品',
    produceListTextFive04: '450万PCS',
    produceListTitleSix: '台湾精密拉簧机',
    produceListTextSix01: '15台',
    produceListTextSix02: '设备精度高，生产拉簧类产品稳定性高',
    produceListTextSix03: '普通德式、英式拉簧，产品主要应用在电子电器、开关等等，可生产范围φ0.1mm-φ0.8mm线径的拉力弹簧',
    produceListTextSix04: '500万PCS',
    produceListTitleSeven: '日本MEC多功能弹簧机',
    produceListTextSeven01: '15台',
    produceListTextSeven02: '专生产0.03mm-0.3mm线径范围的各类型小产品，主要应用在精密电子或者医疗产品上',
    produceListTextSeven03: '2000万PCS',
    produceListTitleEight: '12轴多功能弹簧机',
    produceListTextEight01: '12轴分别为单独伺服电机控制，转换产品型号高效，节省人员排凸轮的时间，生产0.3mm-2.0mm线径范围的各类型产品，主要生产异形的拉簧、扭簧、线成型类产品',
    produceListTextEight02: '5000万PCS',
    produceListTitleNine: '12轴大型多功能弹簧机',
    produceListTextNine01: '15台',
    produceListTextNine02: '12轴单独操作；换型简便；效率高',
    produceListTextNine03: 'φ3.0以上的各种扭簧、拉簧、线成型',
    produceListTextNine04: '450万PCS',
    produceListTitleTen: '45T-630T连续冲床',
    produceListTextTen01: '50台',
    produceListTextTen02: '金丰/东泰/广锻',
    produceListTextTen03: '精密冲床、性能稳定，可生产材料厚度0.1mm-6.0mm各种材质的精密五金冲压产品及机壳等拉伸产品',
    produceListTitleEleven: '10T-38T精密成型机(扣机)',
    produceListTextEleven01: '9台',
    produceListTextEleven02: '台湾逸昇',
    produceListTextEleven03: '适用于直径0.1mm-5.0mm的镀锌线、不锈钢等材质的线成型各式球簧、卡簧产品生产',
    produceListTitleTwelve: '10T-38T精密成型机(扣机)',
    produceListTextTwelve01: '2套',
    produceListTextTwelve02: '可对各材质产品进行清洗，如镀锌板、铝、铜、不锈钢等 每日（按20H）可清洗2-3T产品，满足36N以上达因测试要求,能达到400μm清洁度标准',
    produceListTitleThirteen: '连续式热风回火炉',
    produceListTextThirteen01: '3台',
    produceListTextThirteen02: '桐庐三立',
    produceListTextThirteen03: '采用上下排列设计，加热温度均匀，使用寿命长，故障率低，可满足产品达因测试及车灯零件脱气测试要求',
    produceListTitleFourteen: '半自动压铆机',
    produceListTextFourteen01: '4台',
    produceListTextFourteen02: '深圳耐克斯',
    produceListTextFourteen03: '生产效率高，适用于铆接各式汽车支架螺钉、螺帽',
    produceListTextFourteen04: '2万件/套',
    produceListTitleFiveTeen: '激光打码机',
    produceListTextFiveteen01: '3台',
    produceListTextFiveteen02: '广州微嵌',
    produceListTextFiveteen03: '满足各类冲压件二维码蚀刻，满足客户对零件可追溯要求',
    produceListTextFiveteen04: '200万件',
    produceListTitleSixTeen: 'CCD视觉检测机',
    produceListTextSixteen01: '5台',
    produceListTextSixteen02: '实现高效率,对卡簧、铆接件外观及尺寸控制自动化检查',
    produceListTextSixteen03: '16万件/台',
    produceListTitleSevenTeen: '气密性检查机',
    produceListTextSeventeen01: '2台',
    produceListTextSeventeen02: '气密性检查精密度高，效率相对较高，满足产品气密性检查需求',
    produceListTitleEightTeen: '振动检测机',
    produceListTextEightTeen01: '22台',
    produceListTextEightTeen02: '高效率实现卡扣卡簧类产品,开口尺寸检查',
    produceListTitleNineTeen: '慢走丝线割机床',
    produceListTextNineTeen01: '4台',
    produceListTextNineTeen02: '进口西部/沙迪克品牌',
    produceListTextNineTeen03: '精度可达0.002mm，稳定性好，加工范围500*300mm,开口尺寸检查',
    detectTitleZH: '检测设备',
    detectTitleEN: 'Testing Equipment',
    detectMainTitleOne: '检测设备 — 弹簧篇',
    detectMainTitleTwo: '检测设备 — 五金篇',
    detectNum: '设备数量：',
    detectBrand: '设备品牌：',
    detectRange: '检测范围：',
    detectTitleOne: '清洁度分析仪',
    detectBrandOne: '德国',
    detectTextOne: '拥有独立的10万级无尘检测室，配备德国进口自动颗粒萃取机与高精度自动颗粒分析仪器，能自动判定萃取物属性，可精准、快速检测零件表面清洁度',
    detectTitleTwo: '拉、压测力机',
    detectBrandTwo: '日本',
    detectTextTwo01: '7台不同量程拉压测力机，5台为日本进口',
    detectTextTwo02: '可检测0-10000N范围的拉压弹簧力度，其中高精度拉压测力机最大量程为10N,精度可达到0.0001N,能精准、快速检测弹簧力度',
    detectTitleThree: '扭力测力机',
    detectTextThree01: '4台',
    detectTextThree02: '测量扭矩范围0-100N.m，可对各种形状，标准、非标准、特殊弹簧的扭矩实施精准检测',
    detectTitleFour: '三次元',
    detectTextFour01: '2台',
    detectTextFour02: '可检测各种形状复杂工件的轮廓和表面形状尺寸，角度和位置检测与质量控制，可以应用3D数模的输入，将成品模具与数模上的定位，尺寸，相干的形位公差，曲线、曲面进行测量，输出图形化报告，直观清楚的反应模具质量',
    detectTitleFive: '单向阀自动全检、包装',
    detectTextFive: '单向阀项目专用CCD尺寸全检与包装自动化一体设备，能精准、快速进行尺寸全检并完成包装',
    detectTitleSix: '尾门弹簧测力机',
    detectTextSix01: '3台',
    detectTextSix02: '为定制专项测力设备，可实现弹簧使用状态进行去程、回程、平均值力度检测，并输出曲线报告',
    detectTitleSeven: '三次元',
    detectTextSeven01: '2台',
    detectTextSeven02: '思瑞三次元',
    detectTextSeven03: '800mm*1000mm*600mm，精度:(2.9+3.5L/1000)μm,可实现产品与3D数模数据对比，完成结构复杂产品尺寸测量',
    detectTitleEight: '视频测量仪',
    detectTextEight01: '5台',
    detectTextEight02: '艾顾品牌',
    detectTextEight03: '400mm*300mm，精度:(3+L/75)μm,可对细小零件实施二维尺寸测量',
    detectTitleNine: '硬度测试仪',
    detectTextNine01: '5台',
    detectTextNine02: '依工、时代品牌各一台，精度可达0.1HV,可对模具配件、冲压金属零件进行洛氏和维氏硬度测量',
    detectTitleTen: '弹簧拉压测力机',
    detectTextTen01: '2台',
    detectTextTen02: 'AIKOH品牌',
    detectTextTen03: '0-450N，精度:0.01N,对金属弹片类产品快速进行弹力测试',
    detectTitleEleven: '产品专用检具',
    detectTextEleven01: '若干',
    detectTextEleven02: '针对较复杂的产品,开发专用检具,实现快速检验与判定',
    environmentTitleZH: '车间环境',
    environmentTitleEN: 'Workshop Environment',
    environmentMainTitleOne: '车间环境 — 弹簧篇',
    environmentMainTitleTwo: '车间环境 — 五金篇',
    environmentTextOne: '车间全景（ 一 ）',
    environmentTextTwo: '车间全景（ 二 ）',
    environmentTextThree: '扣机区',
    environmentTextFour: '45T-160T冲床区域',
    environmentTextFive: '200T-630T冲床区域（ 一 ）',
    environmentTextSix: '200T-630T冲床区域（ 二 ）',
    environmentTextSeven: '包装区（ 一 ）',
    environmentTextEight: '包装区（ 二 ）',
    environmentTextNine: '清洗机',
    environmentTextTen: '模具存放架',
    environmentTextEleven: '线切割车间（ 一 ）',
    environmentTextTwelve: '线切割车间（ 二 ）',
    environmentTextThirteen: '模具制作区（ 一 ）',
    environmentTextFourteen: '模具制作区（ 二 ）',
    environmentTextFifteen: '原材料区',
    environmentTextSixteen: '成品区（ 一 ）',
    environmentTextSeventeen: '成品区（ 二 ）',
  },

  // 弹簧
  spring: {
    breadcrumb: '当前位置： 产品  >  弹簧产品系列  >  ',
    bannerTitleZH: '弹簧产品系列',
    bannerTitleEN: 'SPRING PRODUCT SERIES',
    springTitleZH: '弹簧产品系列',
    springTitleEN: 'SPRING PRODUCT SERIES',
    menulist01: '压簧系列',
    menulist02: '拉簧系列',
    menulist03: '扭簧系列',
    menulist04: '线成型系列',
    menulist05: '涡卷及异型截面材料弹簧系列',
    phoneTitle: '服务咨询热线：',
    phoneNum: '020-8226 9332',
    springTitleOne: '功能及生产技术特点',
    springTitleTwo: '应用场景',
    springTextOne: '压缩弹簧是一种用途非常广泛弹簧元件，能够在多种应用场景中用作控制运动或减震储能。材料丰富，结构简单，端面可以磨平有利于受力稳定，表面可抛丸增加疲劳寿命，可以储存应力满足耐衰减性能要求，精准的弹簧刚度及应力计算使成本更加优化，智能自动化生产控制确保质量要求得以满足。',
    springTextTwo: '压缩弹簧常用于以下应用：汽车避震系统弹簧，汽车离合器阻尼弹簧，汽车电动尾门弹簧，喷射系统（泵和喷油器）弹簧、减震器、制动系统（ABS、ESP、制动执行器）、变速箱控制、皮带和链条张紧系统、油泵。空调压缩机回位弹簧，开关传感器弹簧，精密电子声音传感器弹簧等。',
    springTextThree: '拉伸弹簧是一种带有预紧力的弹簧元件，能够在多种应用场景中用作储能控制运动，钩位结构复杂（有各种线出拉钩型，螺旋拉钩型，卡板拉钩型等），通过弹簧圈并紧预变形产生F0（初拉力），材料可以预镀锌或其他镀层达到防腐蚀性能，CNC成型能高精度控制钩位形状及初拉力。',
    springTextFour: '拉伸弹簧常用于以下应用：汽车继电器回位弹簧，汽车机箱盖回位弹簧，汽车门锁弹簧，刹车控制系统弹簧、汽车座椅调节弹簧，汽车雨刮器拉簧，器械平衡器调节弹簧，门窗稳定器弹簧，环形密封圈弹簧等。',
    springTextFive: '扭转弹簧是一种非常广泛的储能弹簧元件，能够在多种应用场景中通过正反扭转用作储能控制运动，，扭臂结构复杂，簧体常有芯轴支撑，可同时多个螺旋簧体使用，可精确计算应力及扭矩值，CNC智能自动化生产尺寸精度高，扭矩测量时注意摩擦力影响。',
    springTextSix: '扭转弹簧常用于以下应用：汽车VVT回位弹簧，汽车机箱盖锁扣弹簧，汽车门锁拉手复位弹簧，刹车控制系统弹簧、汽车座椅调节弹簧，门铰链复位弹簧等。',
    springTextSeven: '线型弹簧是一种非常广泛的机械运动控制零件，通过CNC成型能够满足客户绝大部分要求，同时可旋锻缩径，搓牙纹，冲扁，冲孔，焊接，包胶注塑等。',
    springTextEight: '线型弹簧常用于以下应用：汽车门锁拉杆，汽车方向机扭杆弹簧，汽车雨刮器拉钩弹簧，座椅骨架系统弹簧、汽车座椅头枕骨架，门铰链锁扣等。',
    springTextNine: '渦卷及异性截面弹簧是一种特殊用途的弹簧元件，能够在多种应用场景中用作储能控制运动，摩擦止滑，复位等。材料截面多样（有圆截面，矩形截面，钢带，梯形，椭圆截面等），结构复杂（有扭簧型，平面渦卷型，恒力弹簧型等），通过FEA设计可数值模拟发现应力集中点并计算输出力值或扭矩，可以局部退火解决R位过小带来的断裂风险，专业的场景测试设计得出科学的疲劳评估，多种复杂的结构都可通过CNC成型。',
    springTextTen: '渦卷及异性截面弹簧常用于以下应用：汽车发动机VVT系统回位弹簧，汽车安全带回位弹簧，汽车门锁弹簧，正时皮带和链条张紧系统、汽车座椅调节弹簧，医疗器械平衡器调节弹簧，门窗稳定器恒力弹簧，洗衣机滚筒止滑弹簧等。',
  },

  // 五金
  hardware: {
    breadcrumb: '当前位置： 产品  >  五金产品系列  >  ',
    bannerTitleZH: '五金产品系列',
    bannerTitleEN: 'HARWARE PRODUCT SERIES',
    hardwareTitleZH: '弹簧产品系列',
    hardwareTitleEN: 'HARWARE PRODUCT SERIES',
    menulist01: '汽车冲压铝件系列',
    menulist02: '结构件焊铆件系列',
    menulist03: '精密拉伸机壳系列',
    menulist04: '弹性卡扣垫圈系列',
    menulist05: '不锈钢贵金属系列',
    menulist06: '端子类及其它系列',
    phoneTitle: '服务咨询热线：',
    phoneNum: '020-8226 9332',
    hardwareTitleOne: '应用场景',
    hardwareTextOne: '车灯PCBA散热片,ECU屏蔽罩,内控系统PCBA散热支架,控制系统铝盖,新能源电池壳等',
    hardwareTextTwo: '汽车电控支架,汽车车灯装配固定座,汽车内饰支架,汽车空调支架,汽车门锁支架等',
    hardwareTextThree: '不锈钢拉伸汽车水泵电机屏蔽罩,汽车电机外壳,汽车电磁阀壳,汽车灯泡座等',
    hardwareTextFour: '电动尾门弹簧球头卡扣,发动机片,雨刮拉簧,汽车各类弹性垫圈等',
    hardwareTextFive: '氢能源电池集流板,汽车控制PCBA屏蔽罩,汽车启动电机精密配重块等',
    hardwareTextSix: '汽车连接器端子,新能源电池端子,镀锡铜件等',
  }
}



// WEBPACK FOOTER //
// ./src/language/zh.js